// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1kkUU","row":"styles_row__2nYIV"};